import ReactDOM from 'react-dom/client'
import App from './App'
import './index.less'
import { authConfig } from 'shared/auth/auth.config'
import { initialiseSentry, registerServiceWorker } from 'Utils/common.utils.ts'
import { Authenticate, AuthProvider, validateUserSession } from 'shared/auth/auth.utils'
import { CookieSync } from 'shared/auth/components/CookieSync/CookieSync'

registerServiceWorker()
initialiseSentry()
validateUserSession()

ReactDOM.createRoot(document.getElementById('root')!).render(
    <CookieSync>
        <AuthProvider config={authConfig}>
            <Authenticate>
                <App />
            </Authenticate>
        </AuthProvider>
    </CookieSync>
)
